import type { GatsbyBrowser } from 'gatsby';

import { PageWrapper, RootWrapper } from 'components';
import 'i18n';


export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => <RootWrapper>{element}</RootWrapper>;
export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element }) => <PageWrapper>{element}</PageWrapper>;
